// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.GetConfigWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetConfigRequestDto, GetConfigResponseDto } from '../..';

export const GetConfigWebApiHandler_getConfig_Path = '/api/web/v1/getConfig';

/**
 * Get config
 */
export const GetConfigWebApiHandler_getConfig = (postData: GetConfigRequestDto, client = getClient()) => {
  return httpFrontEndRequest<never, GetConfigRequestDto, GetConfigResponseDto>(
    {
      endpoint: GetConfigWebApiHandler_getConfig_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
